import useSubmitStore from "stores/submit"
import extractIdFromLink from "utils/extractIdFromLink"
import useT from "utils/useT"

interface Props {
  Loading: boolean
}

const SearchBar = ({ Loading }: Props) => {
  const t = useT()
  const setSearch = useSubmitStore((state) => state.setSearch)
  const search = useSubmitStore((state) => state.search)
  const handleSearch = (searchTerm: string) => {
    if (searchTerm.includes("appsliced")) {
      setSearch(searchTerm)
      return
    }
    if (searchTerm.includes("http") || searchTerm.includes(".com")) {
      setSearch(extractIdFromLink(searchTerm))
      return
    }

    setSearch(searchTerm)
  }
  return (
    <div className="content searchbox">
      <div className="search-box search-color bg-highlight rounded-m mb-3 d-flex align-items-center position-relative">
        <i className="fa fa-search"></i>
        <input
          type="text"
          dir="auto"
          value={search}
          onChange={(e) => handleSearch(e.target.value)}
          className="border-0"
          placeholder={t.submit.search}
        />
        {Loading && search?.length > 0 && (
          <div
            style={{ transform: "scale(0.7)" }}
            className="d-flex justify-content-center "
          >
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
        {search && (
          <i
            onClick={() => handleSearch("")}
            style={{ cursor: "pointer" }}
            className="fa fa-times p-3 pe-4"
          ></i>
        )}
      </div>
    </div>
  )
}

export default SearchBar
